import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahFreeExploreEditor = () => {
  const [form, setForm] = useState({
    titleEn: "",
    titleAr: "",
    titleKu: "",
    descriptionEn: "",
    descriptionAr: "",
    descriptionKu: "",
    bottomTextEn: "",
    bottomTextAr: "",
    bottomTextKu: "",
    buttonTextEn: "",
    buttonTextAr: "",
    buttonTextKu: "",
    bigVideoUrl: "",
    smallVideo1Url: "",
    smallVideo2Url: "",
  });

  const [loading, setLoading] = useState(true);

  // ==============================
  // LOAD DATA (3 LANGUAGES)
  // ==============================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VFExpSection?lang=en`),
          axios.get(`${API_BASE}/api/VFExpSection?lang=ar`),
          axios.get(`${API_BASE}/api/VFExpSection?lang=ku`),
        ]);

        setForm({
          // EN
          titleEn: en.data.title,
          descriptionEn: en.data.description,
          bottomTextEn: en.data.bottomText,
          buttonTextEn: en.data.buttonText,

          // AR
          titleAr: ar.data.title,
          descriptionAr: ar.data.description,
          bottomTextAr: ar.data.bottomText,
          buttonTextAr: ar.data.buttonText,

          // KU
          titleKu: ku.data.title,
          descriptionKu: ku.data.description,
          bottomTextKu: ku.data.bottomText,
          buttonTextKu: ku.data.buttonText,

          // VIDEOS (identik — vetëm një version)
          bigVideoUrl: en.data.bigVideo,
          smallVideo1Url: en.data.smallVideo1,
          smallVideo2Url: en.data.smallVideo2,
        });

        setLoading(false);
      } catch (err) {
        console.error("Error loading VFExp data:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ==============================
  // SAVE CHANGES
  // ==============================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VFExpSection/1`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("VFExplore updated successfully!");
    } catch (err) {
      console.error(err);
      alert("Save failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  const LANGS = ["En", "Ar", "Ku"];

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Voyah FREE – Explore Section Editor</h2>

      {/* ==============================
          TEXT INPUTS PER LANGUAGE
      =============================== */}
      <div className="row">
        {LANGS.map((lang) => (
          <div className="col-lg-4 col-md-6 mb-4" key={lang}>
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary mb-3">{lang} Version</h5>

                <label className="form-label">Title</label>
                <input
                  className="form-control mb-2"
                  name={`title${lang}`}
                  value={form[`title${lang}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Description</label>
                <textarea
                  className="form-control mb-2"
                  rows={4}
                  name={`description${lang}`}
                  value={form[`description${lang}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Bottom Text</label>
                <textarea
                  className="form-control mb-2"
                  rows={3}
                  name={`bottomText${lang}`}
                  value={form[`bottomText${lang}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Button Text</label>
                <input
                  className="form-control"
                  name={`buttonText${lang}`}
                  value={form[`buttonText${lang}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ==============================
          VIDEO URL INPUTS
      =============================== */}
      <h4 className="fw-bold mt-5 mb-3">Videos (YouTube / Vimeo / embed URLs)</h4>

      <div className="mb-3">
        <label className="form-label fw-semibold">Big Video URL</label>
        <input
          className="form-control"
          name="bigVideoUrl"
          value={form.bigVideoUrl}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Small Video 1 URL</label>
        <input
          className="form-control"
          name="smallVideo1Url"
          value={form.smallVideo1Url}
          onChange={handleChange}
        />
      </div>

      <div className="mb-4">
        <label className="form-label fw-semibold">Small Video 2 URL</label>
        <input
          className="form-control"
          name="smallVideo2Url"
          value={form.smallVideo2Url}
          onChange={handleChange}
        />
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default VoyahFreeExploreEditor;
